module.exports = __webpack_public_path__ + "static/media/icon-blockchain.6ebf4d94.svg";